module.exports = __webpack_public_path__ + "static/media/task-complete.1763d59e.svg";